import { useLocation, useNavigate } from 'react-router-dom'
import { backButtonTemplate } from '../backButtonTemplate'

export default function BackButton() {
  const navigate = useNavigate()
  const location = useLocation()
  const normalizedPath = location.pathname.replace(/\/+$/, '') || '/'
  const isPartyPage =
    normalizedPath.startsWith('/game/mutelu/party') ||
    normalizedPath.startsWith('/game/mutelu/party-join')

  if (backButtonTemplate.excludePaths.includes(normalizedPath)) {
    return null
  }

  const onBack = () => {
    if (window.history.length > 1) {
      navigate(-1)
      return
    }
    navigate('/game/mutelu/activity')
  }

  return (
    <button
      type="button"
      aria-label="ย้อนกลับ"
      onClick={onBack}
      className={
        isPartyPage
          ? 'absolute left-1 -top-4 z-40 h-8 w-8 text-[#5b461c] transition hover:opacity-75'
          : backButtonTemplate.className
      }
    >
      <svg
        aria-hidden="true"
        viewBox="0 0 24 24"
        className="h-5 w-5"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M15 18L9 12L15 6"
          stroke="currentColor"
          strokeWidth="2.3"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </svg>
    </button>
  )
}
